import React, { useState } from 'react';
import { Modal, Button, Row, Col } from 'antd';
import { useSelector } from 'react-redux';
import LabelSelect from '../../../../../components/select/LabelSelect';

export default function ModalAgregarServicios({
  visible,
  onClose,
  onAgregarServicio
}) {
  const serviciosElegibles = useSelector((state) => state.ordenesPagoReducer.listaAsistenciasElegibles);
  const [servicioSeleccionado, setServicioSeleccionado] = useState(null);

  const handleClose = () => {
    setServicioSeleccionado(null);
    onClose();
  };

  const handleAgregar = () => {
    if (servicioSeleccionado) {
      onAgregarServicio(servicioSeleccionado);
      setServicioSeleccionado(null);
      handleClose();
    }
  };

  return (
    <Modal
      title="Agregar Servicios a la Orden"
      open={visible}
      onCancel={handleClose}
      footer={[
        <Button key="close" onClick={handleClose}>
          Cerrar
        </Button>,
        <Button
          key="agregar"
          type="primary"
          onClick={handleAgregar}
          disabled={!servicioSeleccionado}
        >
          Agregar
        </Button>
      ]}
      width={600}
      className="pagos-v2-modal"
    >
      <Row gutter={[12, 12]}>
        <Col xs={24}>
          <LabelSelect
            placeholder="Servicios elegibles..."
            opciones={serviciosElegibles}
            value={servicioSeleccionado}
            onChange={(val) => setServicioSeleccionado(val)}
          />
        </Col>
      </Row>
    </Modal>
  );
}
